/**
 * Working branch for an interactive editing batch. The batch id is
 * client-generated (one per "stage a bunch of docs then PR" session); it is
 * sanitized hard so it can never escape the `shelf/draft/` namespace. Returns
 * null for an invalid id.
 */
export function draftBranchForBatch(batchId: string): string | null {
  if (!/^[A-Za-z0-9-]{1,64}$/.test(batchId)) return null;
  return `shelf/draft/${batchId}`;
}
